import { render, staticRenderFns } from "./handingFeeList.vue?vue&type=template&id=0a404019"
import script from "./handingFeeList.vue?vue&type=script&lang=js"
export * from "./handingFeeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports